import React, { useEffect, useState } from "react";
import axios from "axios";
import "./showSchools.css";


export default function ShowSchools() {
  const [schools, setSchools] = useState([]);

  useEffect(() => {
    axios.get("http://localhost:5000/schools")
      .then(res => setSchools(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="school-list" style={{ padding: 16, maxWidth: 1100, margin: "0 auto" }}>
      <h2 className="page-title">Schools</h2>
      <div className="grid" style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
        gap: 16
      }}>
        {schools.map((s) => (
          <div className="card" key={s.id} style={{ border: "1px solid #eee", borderRadius: 12, padding: 12 }}>
            <div style={{ height: 150, overflow: "hidden", borderRadius: 8, marginBottom: 8 }}>
              {s.image && (
                <img className="school-img"
                  src={`http://localhost:5000/schoolImages/${s.image}`}
                  alt={s.name}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              )}
            </div>
            <h3 className="school-name" style={{ margin: "6px 0" }}>{s.name}</h3>
            <p className="school-address" style={{ margin: 0 }}>{s.address}</p>
            <p className="school-city" style={{ margin: 0, opacity: 0.8 }}>{s.city}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
